import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, RotateCcwIcon, ArrowLeftIcon } from 'lucide-react';
interface ClosingSlideProps {
  onRestart: () => void;
  onRequestInfo: () => void;
  onBack: () => void;
}
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 14
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.35,
      ease: 'easeOut'
    }
  }
};
export function ClosingSlide({
  onRestart,
  onRequestInfo,
  onBack
}: ClosingSlideProps) {
  return <div className="flex-1 flex items-center justify-center px-5 py-10" data-id="element-26">
      <motion.div className="w-full max-w-sm" variants={containerVariants} initial="hidden" animate="visible" data-id="element-27">
        <motion.div variants={itemVariants} data-id="element-28">
          <button onClick={onBack} className="flex items-center gap-1 text-xs font-semibold text-clinical-muted active:text-clinical-text transition-colors mb-5" data-id="element-29">
            <ArrowLeftIcon className="w-3.5 h-3.5" data-id="element-30" />
            Back
          </button>
        </motion.div>

        <motion.div variants={itemVariants} className="text-center mb-6" data-id="element-31">
          <div className="inline-flex items-center gap-1.5 bg-era-teal-light text-era-teal text-[11px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full mb-5" data-id="element-32">
            Survey Complete
          </div>

          <h1 className="text-2xl font-bold text-clinical-text leading-tight mb-3" data-id="element-33">
            Variation reflects uncertainty
          </h1>

          <p className="text-clinical-secondary text-sm leading-relaxed" data-id="element-34">
            Differences in timing, goals, and mechanisms suggest a lack of
            alignment in managing IgAN progression. Understanding these gaps is
            key to improving long-term outcomes.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-white border-2 border-gray-100 rounded-2xl p-5 mb-5" data-id="element-35">
          <div className="grid grid-cols-3 gap-3 text-center" data-id="element-36">
            <div data-id="element-37">
              <div className="text-xl font-black text-era-red" data-id="element-38">4</div>
              <div className="text-[10px] font-semibold text-clinical-muted mt-0.5 uppercase tracking-wider" data-id="element-39">
                Questions
              </div>
            </div>
            <div data-id="element-40">
              <div className="text-xl font-black text-era-orange" data-id="element-41">Low</div>
              <div className="text-[10px] font-semibold text-clinical-muted mt-0.5 uppercase tracking-wider" data-id="element-42">
                Consensus
              </div>
            </div>
            <div data-id="element-43">
              <div className="text-xl font-black text-era-teal" data-id="element-44">High</div>
              <div className="text-[10px] font-semibold text-clinical-muted mt-0.5 uppercase tracking-wider" data-id="element-45">
                Variation
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="grid gap-2.5" data-id="element-46">
          <button onClick={onRequestInfo} className="w-full inline-flex items-center justify-center gap-2 bg-era-red active:bg-era-red-dark text-white font-bold px-5 py-3.5 rounded-2xl transition-colors duration-150 text-sm" data-id="element-47">
            <MailIcon className="w-4 h-4" data-id="element-48" />
            Yes, send me further information
          </button>

          <button onClick={onRestart} className="w-full flex items-center justify-center gap-2 bg-gray-50 border-2 border-gray-100 rounded-2xl px-4 py-3 active:border-clinical-muted transition-all duration-150" data-id="element-49">
            <RotateCcwIcon className="w-3.5 h-3.5 text-clinical-muted" data-id="element-50" />
            <span className="text-xs font-bold text-clinical-secondary" data-id="element-51">
              Retake as a different role
            </span>
          </button>
        </motion.div>
      </motion.div>
    </div>;
}